import styled from "styled-components";

export const FileInput = styled.input`
  display: block;
  width: 100%;
  height: 40px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
  padding: 8px 15px;

  &:hover {
    background-color: #edeff9;
    border-color: #005dff;
  }

  &::file-selector-button {
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px 10px;
    margin-right: 10px;
  }
`;
